const STOP_PROPAGATION = (ev: React.MouseEvent) => ev.stopPropagation();

/**
 * @deprecated Reach out to `#csds-eng-support` for suggested alternatives.
 */
export function stopPropagation(fn?: (ev: React.MouseEvent) => any): (ev: React.MouseEvent) => void {
  if (!fn) {
    // return a constant to prevent unnecessary react re-renders
    return STOP_PROPAGATION;
  }
  return (ev: React.MouseEvent) => {
    ev.stopPropagation();
    fn(ev);
  };
}
